import React from 'react'
import { Icon } from 'antd-mobile'
import injectSheet from 'react-jss'
import { STEPPER_MAX } from '../constants/app'
import { gtag } from 'helpers/gtag'

class NativeStepper extends React.Component {
  render () {
    const {
      classes,
      disabled,
      min = 0,
      max = STEPPER_MAX,
      value = 0,
      onMinusClick = (newValue) => { },
      onPlusClick = (newValue) => { },
    } = this.props

    return (
      <div disabled={disabled} className={classes.container}>
        <button
          className={classes.button}
          disabled={disabled || (value <= min)}
          onClick={() => {
            const newValue = Math.max(value - 1, min)
            gtag('event', 'stepper_click', {
              event_category: 'stepper',
              event_label: 'minus',
              value: 1,
            })
            onMinusClick(newValue)
          }}
        >
          <Icon
            style={{ margin: 0 }}
            className={classes.buttonIcon}
            type='minus'
            size='xxs'
          />
        </button>

        <div className={classes.number}>{value}</div>

        <button
          className={classes.button}
          disabled={disabled || (value >= max)}
          onClick={() => {
            const newValue = Math.min(value + 1, max)
            gtag('event', 'stepper_click', {
              event_category: 'stepper',
              event_label: 'plus',
              value: 1,
            })
            onPlusClick(newValue)
          }}
        >
          <Icon
            style={{ margin: '0 auto' }}
            className={classes.buttonIcon}
            type='plus'
            size='xxs'
          />
        </button>
      </div>
    )
  }
}

const styles = {
  container: {
    width: '100%',
    minWidth: 80,
    height: 34,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 30,
    height: 30,
    padding: 0,
    fontSize: '100%',
    fontFamily: 'inherit',
    borderRadius: '50%',
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#4A8CA1',
    backgroundColor: 'white',
    cursor: 'pointer',
    '&:active': {
      backgroundColor: 'rgb(221, 221, 221)',
    },
    '&:disabled': {
      backgroundColor: 'white',
      opacity: 0.3,
    },
  },
  buttonIcon: {
    color: '#4A8CA1',
  },
  number: {
    flex: 1,
    textAlign: 'center',
    fontSize: 16,
    fontWeight: 400,
    color: 'black',
  },
}

export default injectSheet(styles)(NativeStepper)



// WEBPACK FOOTER //
// ./src/components/NativeStepper.js